import { render, staticRenderFns } from "./KGridItem.vue?vue&type=template&id=0d0aefa8&scoped=true&"
import script from "./KGridItem.vue?vue&type=script&lang=js&"
export * from "./KGridItem.vue?vue&type=script&lang=js&"
import style0 from "./KGridItem.vue?vue&type=style&index=0&id=0d0aefa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0aefa8",
  null
  
)

export default component.exports